import cn from "classnames";
import { ReactNode } from "react";
import { Input } from "../Input/Input";
import styles from "./StaticValueField.module.scss";

export interface StaticValueFieldProps {
  readonly id?: string;
  readonly label: ReactNode;
  readonly value: number | string;
  readonly unit?: string;
  readonly className?: string;
  readonly unitClassName?: string;
  readonly isError?: boolean;
  readonly outlined?: boolean;
  readonly disabled?: boolean;
  readonly readOnly?: boolean;
}

export default function StaticValueField({
  id,
  label,
  value,
  unit,
  className,
  unitClassName,
  isError,
  outlined,
  disabled = false,
  readOnly = true,
}: StaticValueFieldProps) {
  return (
    <Input
      id={id}
      size='small'
      label={<span className={styles.label}>{label}</span>}
      value={value.toString()}
      readOnly={readOnly}
      disabled={disabled}
      outlined={outlined}
      wrapClassName={cn(styles.field, className, {
        [styles.error]: isError,
      })}
      addonAfter={
        unit ? <span className={cn(styles.addon, unitClassName)}>{unit}</span> : undefined
      }
    />
  );
}
